"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SecondaryNavDefaultProps = exports.SecondaryNav = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SecondaryNav = function SecondaryNav(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('secondarynav-component', props.classNames, _defineProperty({}, "secondarynav-component-color-".concat(props.color), true))
  }, props.children);
};

exports.SecondaryNav = SecondaryNav;
SecondaryNav.propTypes = {
  color: _propTypes.default.oneOf(['default', 'secondary', 'none']).isRequired,
  classNames: _propTypes.default.any,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)])
};
var SecondaryNavDefaultProps = {
  color: 'default'
};
exports.SecondaryNavDefaultProps = SecondaryNavDefaultProps;
SecondaryNav.defaultProps = SecondaryNavDefaultProps;
var _default = SecondaryNav;
exports.default = _default;